<template>
  <div class="contranter">
    <div id="main">
      <Topbar :tab_index="tab_index" :had_login="had_login"></Topbar>
      <div class="gl-box" v-for="(item, i) in 7" :key="i" :class="i % 2 == 1 ? 'gl-xl' : ''">
        <div class="gl-con-ta">
          <div class="gl-lff">
            <img class="gl-ic-a" v-if="i == 0" src="../assets/gl-0.png" />
            <img class="gl-ic-a" v-if="i >= 1 && i <= 2" src="../assets/gl-1.png" />
            <img class="gl-ic-a" v-if="i > 2 && i <= 6" src="../assets/gl-2.png" />
            <div class="gl-title">2022年<br />雅生室内设计奖</div>
          </div>
          <div class="gl-img">
            <img class="gl-ii" :src="awardList[i].url" />
          </div>
          <div class="gl-msg-box">
            <div class="gl-name">{{ awardList[i].name }}</div>
            <div class="gl-com">{{ awardList[i].auto }}</div>
            <img class="gl-pro-ti-a" v-if="i != 3 && i != 4" src="../assets/pro-icon-1.png" />
            <img class="gl-pro-ti" v-if="i == 3 || i == 4" src="../assets/pro-icon.png" />
            <img class="gl-pro-more" src="../assets/more-btn.png" @click="goToDetail(awardList[i].id)" />
          </div>
        </div>
      </div>
      <div class="gl-lbox gl-xt">
        <div class="gl-con-ta">
          <img class="gl-ic-d" src="../assets/gl-3.png" />
          <div class="gl-title">2022年 雅生室内设计奖</div>
          <div class="gl-other">
            <div class="gl-ott" v-for="(item, i) in awardList" :key="i" @click="goToDetail(item.id)" v-if="i > 6">
              <img class="gl-oim" :class="item.is_sc ? 'gl-oim-up' : ''" :src="item.url" />
              <div class="gl-cov">
                <div class="gl-titsss">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../api/api";
import ops from "../leo.wang.util/operator.string";
import Topbar from "../components/Topbar.vue";
import pub from "../common/pub.js";
import Swiper from "swiper";
import $ from "jquery";
export default {
  name: "Dashboard",
  components: {
    Topbar: Topbar,
  },
  data() {
    return {
      title: "AXOR室内设计奖",
      tab_index: 2,
      had_login: false,

      awardList: [
        {
          id: 1,
          url: "https://cdnzn.kai-dian.com/axor/v2/award1.jpg",
          name: "太平湖安卓梅达酒店",
          auto: "谢银秋",
        },
        {
          id: 2,
          url: "https://cdnzn.kai-dian.com/axor/v2/award2.jpg",
          name: "内外之间自然山野中的各得其所",
          auto: "目心设计",
        },
        {
          id: 3,
          url: "https://cdnzn.kai-dian.com/axor/v2/award3.jpg",
          name: "BURNING-SPORT",
          auto: "陈辰",
        },
        {
          id: 4,
          url: "https://cdnzn.kai-dian.com/axor/v2/award4.jpg",
          name: "绿地太湖城",
          auto: "朱墨",
          is_sc: true,
        },
        {
          id: 5,
          url: "https://cdnzn.kai-dian.com/axor/v2/award5.jpg",
          name: "猫狗星球",
          auto: "季意空间设计",
        },
        {
          id: 6,
          url: "https://cdnzn.kai-dian.com/axor/v2/award6.jpg",
          name: "现代性的再定义-设计东方「比弗利山庄」",
          auto: "齐明",
        },
        {
          id: 7,
          url: "https://cdnzn.kai-dian.com/axor/v2/award7.jpg",
          name: "浮生若梦",
          auto: "郑军",
        },
        {
          id: 8,
          url: "https://cdnzn.kai-dian.com/axor/v2/award8.jpg",
          name: "赵艺哲.室之岁华，其曰可读",
        },
        {
          id: 9,
          url: "https://cdnzn.kai-dian.com/axor/v2/award9.png",
          name: "刘硕.玫瑰山庄33栋参赛作品",
        },
        {
          id: 10,
          url: "https://cdnzn.kai-dian.com/axor/v2/award10.jpg",
          name: "田艾灵.连璧餐厅",
        },
        {
          id: 11,
          url: "https://cdnzn.kai-dian.com/axor/v2/award11.jpg",
          name: "黎晓军.1979雾山厂盒精品酒店",
        },
        {
          id: 12,
          url: "https://cdnzn.kai-dian.com/axor/v2/award12.jpg",
          name: "宋超.跑车也要住别墅",
        },
        {
          id: 13,
          url: "https://cdnzn.kai-dian.com/axor/v2/award13.jpeg",
          name: "邬勇.孝丰镇白杨村亲子田园综合体",
        },
        {
          id: 14,
          url: "https://cdnzn.kai-dian.com/axor/v2/award14.jpg",
          name: "寻同空间设计.与简朴共生·伴光影而居",
        },
        {
          id: 15,
          url: "https://cdnzn.kai-dian.com/axor/v2/award15.jpg",
          name: "周晓安.中航樾园",
        },
        // {
        //   id:16,
        //   url:'https://cdnzn.kai-dian.com/axor/v2/award16.jpg',
        //   name:''
        // },
        {
          id: 17,
          url: "https://cdnzn.kai-dian.com/axor/v2/award17.jpg",
          name: "朱磊.行星色爆-TIKKURILA-艺术涂料",
        },
        {
          id: 18,
          url: "https://cdnzn.kai-dian.com/axor/v2/award18.jpg",
          name: "赵紫轩.誉锦堂SPA会所-国贸总店",
          is_sc: true,
        },
        // ,{
        //   id:19,
        //   url:'https://cdnzn.kai-dian.com/axor/v2/award19.jpg',
        //   name:''
        // },{
        //   id:20,
        //   url:'https://cdnzn.kai-dian.com/axor/v2/award20.jpg',
        //   name:''
        // }
      ],
    };
  },
  methods: {
    goToDetail(id) {
      this.$router.push("/pro/" + id);
    },
  },
  created() {
    //window.document.title = this.title;
    let that = this;
  },
  mounted() {
    let that = this;
    let phone_number = localStorage.getItem("mobile");
    if (phone_number) {
      this.had_login = true;
      api
        .getMyInfo({
          user_phone: ops.encode(phone_number),
        })
        .then((res) => {
          that.u_info = res.data.data.info;
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.gl-box {
  background: #e9e2d9;
  overflow: hidden;
}

.gl-lbox {
  overflow: hidden;
}

.gl-xl {
  background: #bebde4;
}

.gl-xt {
  background: #ffaa7c;
}

.gl-title {
  margin-top: 0.1rem;
  font-size: 0.4rem;
  color: rgba(0, 0, 0, 1);
  text-align: center;
}

.gl-con-ta {
  width: 15.4rem;
  margin: 0 auto;
  padding-top: 1.05rem;
  padding-bottom: 1.05rem;
  overflow: hidden;
}

.gl-ic-a {
  width: 1.82rem;
  display: block;
  margin: 0 auto;
}

.gl-ic-d {
  width: 3.32rem;
  margin: 0 auto;
}
.gl-img {
  position: relative;
  width: 7.29rem;
  height: 4.85rem;
  overflow: hidden;
  float: left;
  margin-left: 0.81rem;
}

.gl-ii {
  width: 7.29rem;
}

.gl-pro-ti {
  display: block;
  width: 0.64rem;
  margin-top: 0.3rem;
}

.gl-pro-ti-a {
  display: block;
  width: 1.57rem;
  margin-top: 0.3rem;
}

.gl-name {
  font-size: 0.24rem;
  margin-top: 0.56rem;
  width: 3.5rem;
}

.gl-com {
  font-size: 0.18rem;
}

.gl-msg-box {
  margin-left: 0.53rem;
  margin-top: 1rem;
  float: left;
  text-align: left;
  margin-top: 0.33rem;
}

.gl-pro-more {
  display: block;
  margin-top: 0.69rem;
  width: 1.4rem;
}

.gl-other {
  width: 11.6rem;
  margin: 0.7rem auto;
  overflow: hidden;
}

.gl-ott {
  position: relative;
  width: 3.74rem;
  height: 2.5rem;
  margin-right: 0.1rem;
  margin-bottom: 0.1rem;
  overflow: hidden;
  float: left;
}

.gl-oim {
  display: block;
  width: 100%;
}

.gl-oim-up {
  width: 4.5rem;
}

.gl-cov {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0px;
  left: 0px;
  opacity: 0;
  transition: opacity 300ms linear;
}

.gl-cov:hover {
  opacity: 1;
}

.gl-titsss {
  font-size: 0.24rem;
  color: rgba(255, 255, 255, 1);
  width: 3rem;
  margin: 0.8rem auto 0px;
  text-align: center;
}
.gl-lff {
  float: left;
  margin-top: 0.76rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Last.vue